import { render, staticRenderFns } from "./FundingProjectClaims.vue?vue&type=template&id=caaac4e0&"
import script from "./FundingProjectClaims.vue?vue&type=script&lang=js&"
export * from "./FundingProjectClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports